import { type Service } from "@modules/core/services/serviceType"
import { PaymentApi } from "@modules/payment/gateway/paymentApi"
import { StripeCountryCode, StripePlatform } from "@modules/payment/stripeTypes"

export class PaymentService implements Service {
  constructor(private paymentApi: PaymentApi) {}

  init(): Promise<void> {
    return Promise.resolve()
  }

  async createAccountToken(stripePlatform: StripePlatform) {
    return this.paymentApi.createAccountToken(stripePlatform)
  }

  async createBoxStripeAccount(accountToken: string, countryCode: StripeCountryCode, stripePlatform: StripePlatform) {
    return this.paymentApi.createBoxStripeAccount(accountToken, countryCode, stripePlatform)
  }

  async getUpdateBoxAccountLink() {
    return this.paymentApi.getUpdateBoxAccountLink()
  }
  async createUserStripeAccount(accountToken: string, countryCode: StripeCountryCode, stripePlatform: StripePlatform) {
    return this.paymentApi.createUserStripeAccount(accountToken, countryCode, stripePlatform)
  }

  async getUpdateUserAccountLink() {
    return this.paymentApi.getUpdateUserAccountLink()
  }

  async getStripeAvailableCountries() {
    return this.paymentApi.getStripeAvailableCountries()
  }

  async getStripePublicKey(stripePlatform: StripePlatform) {
    return this.paymentApi.getStripePublicKey(stripePlatform)
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async onLoggedOut(): Promise<void> {}
}
